import { useState } from "react";
import Smarty from "smartystreets-javascript-sdk";
import { useThrottledCallback } from "use-debounce";

interface Suggestion {
  streetLine: string;
  secondary: string;
  city: string;
  state: string;
  zipcode: string;
  entries: number;
}

const useAddressSuggestions = () => {
  const [suggestions, setSuggestions] = useState<string[]>([]);

  const smartyCredentials = new Smarty.core.SharedCredentials(
    "100800035238803617",
    "www.webstaurantstore.com",
  );
  const smartyClientBuilder = new Smarty.core.ClientBuilder(
    smartyCredentials,
  ).withLicenses(["us-autocomplete-pro-cloud"]);

  smartyClientBuilder.baseUrl =
    "https://us-autocomplete-pro.api.smartystreets.com/lookup";

  const smartyClient = smartyClientBuilder.buildUsAutocompleteProClient();

  const suggestionToString = (suggestion: Suggestion): string => {
    return `${suggestion.streetLine}${
      suggestion.secondary ? ` ${suggestion.secondary}` : ""
    }, ${suggestion.city}, ${suggestion.state} ${suggestion.zipcode}`;
  };

  const updateSuggestions = useThrottledCallback(async (search: string) => {
    try {
      const smartyLookup = new Smarty.usAutocompletePro.Lookup(search);

      smartyLookup.maxResults = 5;

      await smartyClient.send(smartyLookup);

      setSuggestions(smartyLookup.result.map(suggestionToString));
    } catch (error) {
      clearSuggestions();
    }
  }, 750);

  const clearSuggestions = () => {
    setSuggestions([]);
  };

  return {
    suggestions,
    updateSuggestions,
    clearSuggestions,
  };
};

export default useAddressSuggestions;
